import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { Provider } from '../model/classes/provider.class';

@Injectable()
export class ProvidersService {
  private url = 'api/provider';

  constructor(private sxHttp: SxHttpService) {}

  guardar(provider: Provider) {
    return this.sxHttp
      .post(this.url, provider)
      .toPromise()
      .then(response => response.json().data as Provider);
  }

  getProvider(codProvider: string): Observable<Provider> {
    return this.sxHttp
      .get(this.url + '/' + codProvider)
      .map(result => result.json().data as Provider);
  }

  getForList(): Observable<ItemGeneralListado[]> {
    return this.sxHttp.get(this.url).map(response => {
      return response.json().data.map(provider => {
        return {
          id: provider.codProvider,
          Titulo: provider.codProvider,
          Descripcion: provider.descripcion,
          Imagen: provider.icono,
        };
      }) as ItemGeneralListado[];
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/providers.service.ts